import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../Components/Layout/Layout";
import userImage from "../Assets/Images/user.png";
import { useDispatch, useSelector } from "react-redux";
import LoaderComponent from "../Components/common/LoaderComponent";
import RightTopSection from "../Components/Layout/RightTopSection";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row as TableRow,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table";
import PaginationComponent from "../Components/common/PaginationComponent";
import {
  getRequestedPacksAction,
  updatePackStatusAction,
} from "../Redux/Action/AddOnPackAction";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";

export default function Requests() {
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRequest, setSelectedRequest] = useState("");
  const dispatch = useDispatch();
  const requestList = useSelector((state) => state?.packsSlice?.requests);

  useEffect(() => {
    const payload = {
      page: currentPage,
      limit: 20,
    };
    dispatch(getRequestedPacksAction(payload)).finally(() => {
      setIsLoading(false);
    });
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber - 1);
  };

  const handleStatusChange = (id, status) => {
    dispatch(
      updatePackStatusAction({
        requestId: id,
        status: status,
      })
    ).then((res) => {
      if (res?.payload?.statusCode === 200) {
        toast.success(res?.payload?.message || "Status Updated Successfully");
        const payload = {
          page: currentPage,
          limit: 20,
        };
        dispatch(getRequestedPacksAction(payload));
      } else {
        toast.danger(res?.payload?.message || "Something went Wrong");
      }
    });
  };

  return (
    <Layout>
      <Helmet>
        <html lang="en" />
        <title>Strategy Pack Requests</title>
        <meta name="description" content="Strategy Pack Requests" />
      </Helmet>
      <RightTopSection
        breadcrumb=""
        title="Strategy Pack Requests"
        bellLink="#"
        userImage={userImage}
        type="Requests"
      />
      <>
        <Container fluid>
          <Row>
            <Col lg={8}>
              <Row>
                {/* <Col lg={3}>
                  <div className="action-box">
                    <div className="action-graph">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 34 34"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_2011_5703)">
                          <path
                            d="M9.28393 13.3136H9.55761C10.6113 13.3136 11.4734 14.1757 11.4734 15.2293V24.8082C11.4734 25.8618 10.6113 26.7239 9.55761 26.7239H9.28393C8.23026 26.7239 7.36816 25.8618 7.36816 24.8082V15.2293C7.36816 14.1757 8.23026 13.3136 9.28393 13.3136V13.3136ZM16.947 7.56628C18.0007 7.56628 18.8627 8.42838 18.8627 9.48205V24.8082C18.8627 25.8618 18.0007 26.7239 16.947 26.7239C15.8933 26.7239 15.0312 25.8618 15.0312 24.8082V9.48205C15.0312 8.42838 15.8933 7.56628 16.947 7.56628ZM24.61 18.5135C25.6637 18.5135 26.5258 19.3756 26.5258 20.4293V24.8082C26.5258 25.8618 25.6637 26.7239 24.61 26.7239C23.5564 26.7239 22.6943 25.8618 22.6943 24.8082V20.4293C22.6943 19.3756 23.5564 18.5135 24.61 18.5135V18.5135Z"
                            fill="#4318FF"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2011_5703">
                            <rect
                              width="32.8417"
                              height="32.8417"
                              fill="white"
                              transform="translate(0.526367 0.724243)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="action-graph-icon">
                      <p>Total</p>
                      <h2>{requestList?.totalRequests || 0}</h2>
                    </div>
                  </div>
                </Col> */}
                <Col lg={3}>
                  <div className="action-box">
                    <div className="action-graph">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          fill="#4318FF"
                        />
                        <path
                          d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm2.3 9.2L11 13V7h2v5.2l2.7 1.6-.7 1.4z"
                          fill="#4318FF"
                        />
                      </svg>{" "}
                    </div>
                    <div className="action-graph-icon">
                      <p>Pending</p>
                      <h2>{requestList?.counts?.pending || 0}</h2>
                    </div>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="action-box">
                    <div className="action-graph">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                          fill="#4318FF"
                        />
                      </svg>{" "}
                    </div>
                    <div className="action-graph-icon">
                      <p>Approved</p>
                      <h2>{requestList?.counts?.approved || 0}</h2>
                    </div>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="action-box">
                    <div className="action-graph">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="34"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                          fill="#4318FF"
                        />
                      </svg>{" "}
                    </div>
                    <div className="action-graph-icon">
                      <p>Rejected</p>
                      <h2>{requestList?.counts?.rejected || 0}</h2>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            {/* <Col lg={2}>
              <div className="action-box h-100">
                <select
                  onChange={(e) => {
                    const request = e.target?.value;
                    setSelectedRequest(request);
                  }}
                  className="ad-arrow w-100"
                  value={selectedRequest}
                >
                  <option value="">Select request</option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
            </Col> */}
          </Row>
        </Container>

        <Container fluid className="">
          <div className="table-box-cmn">
            <div className="results-sec">
              <Row>
                <Col
                  lg={12}
                  className="d-flex align-items-center justify-content-between"
                >
                  <div className="table-heading">
                    <h2>All Strategy Pack Requests</h2>
                  </div>
                </Col>
              </Row>
            </div>
            <>
              {isLoading ? (
                <LoaderComponent />
              ) : (
                <div className="table-responsive">
                  <Table
                    className="table-cmn mb-0"
                    data={{
                      nodes:
                        requestList?.videoPacks &&
                        Array.isArray(requestList?.videoPacks) &&
                        requestList?.videoPacks?.length > 0
                          ? requestList?.videoPacks
                          : [],
                    }}
                  >
                    {(tableList) => (
                      <>
                        <Header>
                          <HeaderRow>
                            <HeaderCell className="table-cmn-tr-head">
                              Sno
                            </HeaderCell>
                            <HeaderCell>Date</HeaderCell>
                            <HeaderCell>School Name</HeaderCell>
                            <HeaderCell>Email</HeaderCell>
                            <HeaderCell>Pack Requested</HeaderCell>
                            <HeaderCell className="table-cmn-tr-head">
                              Actions
                            </HeaderCell>
                          </HeaderRow>
                        </Header>

                        <Body>
                          {tableList?.length > 0 ? (
                            tableList.map((ele, index) => (
                              <TableRow key={index} className="no-border-row">
                                <Cell>{index + 1}</Cell>
                                <Cell>
                                  {new Date(ele.createdAt).toLocaleDateString()}
                                </Cell>
                                <Cell>{ele?.schoolId?.schoolName}</Cell>
                                <Cell className="active-icon table-cmn-tr-cell">
                                  {ele?.requestedBy?.email}
                                </Cell>
                                <Cell className="active-icon table-cmn-tr-cell">
                                  {ele?.videoPackId?.title}
                                </Cell>
                                <Cell>
                                  <select
                                    className="form-select rounded-pill w-50"
                                    onChange={(e) =>
                                      handleStatusChange(
                                        ele._id,
                                        e.target.value
                                      )
                                    }
                                    defaultValue={ele?.status}
                                  >
                                    {ele?.status === "pending" && (
                                      <option value="pending" disabled>
                                        Pending
                                      </option>
                                    )}
                                    <option value="approved">Approve</option>
                                    <option value="rejected">Reject</option>
                                  </select>
                                </Cell>
                              </TableRow>
                            ))
                          ) : (
                            <div className="data-not-found">
                              <p>No Data Found</p>
                            </div>
                          )}
                        </Body>
                      </>
                    )}
                  </Table>
                  <div className="table-pagina-set">
                    <PaginationComponent
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      totalData={requestList?.length}
                      limit={20}
                      onPageChange={handlePageChange}
                      route={"/requests"}
                    />
                  </div>
                </div>
              )}
            </>
          </div>
        </Container>
      </>
    </Layout>
  );
}
